import CompanyAvailabilityTable from './CompanyAvailabilityTable';

export default CompanyAvailabilityTable;
